import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/entiyInfo/honer.png'


const _withScopeId = n => (_pushScopeId("data-v-452f88b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-box" }
const _hoisted_3 = { class: "informbox" }
const _hoisted_4 = { class: "inform flex f-d" }
const _hoisted_5 = { class: "chooseinform flex j-s-b" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "idBox" }
const _hoisted_8 = { class: "contentbox flex f-d j-s-e" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "iformContent flex j-c a-c" }
const _hoisted_11 = {
  key: 0,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "标题:", -1))
const _hoisted_13 = {
  key: 1,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "内容:", -1))
const _hoisted_15 = {
  key: 2,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "配图:", -1))
const _hoisted_17 = { class: "picture" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"lightgray"} }, "上传荣誉配图", -1))
const _hoisted_20 = ["accept"]
const _hoisted_21 = {
  key: 3,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "标题:", -1))
const _hoisted_23 = {
  key: 4,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "内容:", -1))
const _hoisted_25 = {
  key: 5,
  class: "Imgbox flex j-s-e a-s"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "配图:", -1))
const _hoisted_27 = {
  key: 0,
  class: "img1 flex warp"
}
const _hoisted_28 = {
  key: 1,
  style: {"color":"lightgray"}
}
const _hoisted_29 = ["accept"]
const _hoisted_30 = {
  key: 1,
  class: "img1"
}
const _hoisted_31 = { class: "video" }
const _hoisted_32 = {
  key: 6,
  class: "dialogbox flex j-s-e a-s"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"width":"4rem","font-size":"1.3rem"} }, "标签:", -1))
const _hoisted_34 = { class: "labelList flex warp" }
const _hoisted_35 = ["onInput", "onBlur", "textContent"]
const _hoisted_36 = { class: "dialog-footer" }
const _hoisted_37 = { class: "dialog-footer" }

import { PageBlockAccessSpec } from "@/services/datatype/paging/PageBlockAccessSpec";
import { ArrowRight } from "@element-plus/icons-vue";
import { nextTick, onMounted, reactive, ref, watch } from "vue";
import Brief from "@/components/EntiyInfo/Brief.vue";
import Case from "@/components/EntiyInfo/Case.vue";
import Honor from "@/components/EntiyInfo/Honor.vue";
import CheckType from "@/utils/CheckType";
import { BasicReview } from "@/services/datatype/ipsphere/review/BasicReview";
import { ReviewType } from "@/services/datatype/ipsphere/review/ReviewType";
import {
  OSSCredentialProvider,
  OssTokenConsumer,
} from "@/services/util/oss/OSSCredentialProvider";
import { OSSFederationToken } from "@/services/util/oss/OSSFederationToken";
import OSS from "ali-oss";
import UserTools from "@/services/session/UserTools";
import { EntityInfo } from "@/services/datatype/entity/EntityInfo";
import { ElMessage } from "element-plus";
import { SharedInfo } from "@/services/datatype/share/SharedInfo";
import { SharedInfoType } from "@/services/datatype/share/SharedInfoType";
import Video from "@/components/talkMessage/Video.vue";
import IssueUtils from "@/utils/IssueUtils";
import { KeywordEntity } from "@/services/datatype/keyword/KeywordEntity";
import { UserInfoTabType } from "@/services/datatype/entity/user/UserInfoTabType";
import { useRoute } from "vue-router";
import entiyinfo from "@/api/entiyinfo";

export default /*#__PURE__*/_defineComponent({
  __name: 'EntiyInfoView',
  setup(__props) {

const route = useRoute();
const shareInfo = reactive({
  title: "",
  description: "",
  imageUrls: [],
  keywords: [],
});

const activeIndex = ref<number>(1);
const chooseList = reactive([
  {
    id: 1,
    title: "个人简介",
    content: "个人信息维护",
  },
  {
    id: 2,
    title: "个人荣誉",
    content: "个人荣誉发布",
  },
  {
    id: 3,
    title: "发布案例",
    content: "经验案例发布",
  },
]);
const honer = reactive({
  title: "",
  description: "",
  picture: "",
});
const accept = ref<string>("");
const EntiyInfoDialogState = ref<boolean>(false);
const caseList = reactive([]);
const honorList = reactive([]);
const add = () => {
  if (shareInfo.keywords.some((e) => e == "")) return;
  shareInfo.keywords.push("");
  // 获取焦点
  nextTick(() => {
    (
      document.getElementsByClassName("label-write")[
        document.getElementsByClassName("label-write").length - 1
      ] as HTMLDivElement
    ).focus();
  });
};

const getMessage = (e, index: number) => {
  if (e.target.innerText.length > 9) {
    shareInfo.keywords[index] = e.target.innerText.slice(0, 10);
    (
      document.getElementsByClassName("label-write")[
        document.getElementsByClassName("label-write").length - 1
      ] as HTMLDivElement
    ).innerText = shareInfo.keywords[index];
    (
      document.getElementsByClassName("label-write")[
        document.getElementsByClassName("label-write").length - 1
      ] as HTMLDivElement
    ).blur();
  } else {
    shareInfo.keywords[index] = e.target.innerText;
  }
};
const getLabel = (e, index: number) => {
  if (shareInfo.keywords.filter((x) => x === e.target.innerText).length > 1) {
    shareInfo.keywords[index] = "";
  } else {
    shareInfo.keywords[index] = e.target.innerText;
  }
};

const delate = () => {
  shareInfo.keywords.pop();
};
const clearHonor = () => {
  honer.title = "";
  honer.description = "";
  honer.picture = "";
};
const clearShareInfo = () => {
  shareInfo.title = "";
  shareInfo.description = "";
  shareInfo.imageUrls = [];
  shareInfo.keywords = [];
};

const issuehonor = () => {
  EntiyInfoDialogState.value = true;
};
const sharecase = () => {
  EntiyInfoDialogState.value = true;
};
const chooseInform = (id: number) => {
  activeIndex.value = id;
};

const issue = () => {
  // EntiyInfoDialogState.value = false;
  if (activeIndex.value == 2) {
    const basicReview = new BasicReview();
    basicReview.reviewType = ReviewType.HONOUR;
    basicReview.title = honer.title;
    basicReview.targetEntityId = UserTools.getUserId();
    let initiatorInfo = new EntityInfo();
    initiatorInfo.entityId = UserTools.getUserId();
    basicReview.initiatorInfo = initiatorInfo;
    basicReview.description = honer.description;
    if (honer.picture && honer.picture.length > 0) {
      basicReview.imageUrls = [honer.picture];
    }
    entiyinfo.addBasicReview(basicReview as BasicReview).then((t) => {
      console.log(t);
      if (t) {
        clearHonor();
        ElMessage.success("发布成功");
        EntiyInfoDialogState.value = false;
        getHonorList();
      }
    });
  } else {
    const sharedInfo = new SharedInfo();
    sharedInfo.infoType = SharedInfoType.EXPERIENCE;
    sharedInfo.title = shareInfo.title;
    sharedInfo.description = shareInfo.description;
    sharedInfo.imageUrls = shareInfo.imageUrls;
    if (
      [...new Set(shareInfo.keywords)] &&
      [...new Set(shareInfo.keywords)].length > 0
    ) {
      let keywordEntities = new Array<KeywordEntity>(
        [...new Set(shareInfo.keywords)].length
      );
      let keywordEntity: KeywordEntity;
      for (var keyword of [...new Set(shareInfo.keywords)]) {
        keywordEntity = new KeywordEntity();
        keywordEntity.keyword = keyword;
        keywordEntities.push(keywordEntity);
      }
      sharedInfo.keywordEntities = keywordEntities;
    }
    let initiatorInfo = new EntityInfo();
    initiatorInfo.entityId = UserTools.getUserId();
    sharedInfo.initiatorInfo = initiatorInfo;
    sharedInfo.targetEntityId = UserTools.getUserId();
    entiyinfo.addOrUpdateSharedInfo(sharedInfo).then((t) => {
      if (t) {
        clearShareInfo();
        ElMessage.success("发布成功");
        getCaseList();
        EntiyInfoDialogState.value = false;
      }
    });
  }
};
const changeImg = () => {
  if (activeIndex.value == 2) {
    accept.value = "image/*";
    setTimeout(() => {
      (document.getElementsByClassName("file")[0] as HTMLInputElement).click();
    }, 100);
  } else if (activeIndex.value == 3) {
    accept.value = "image/*,video/*";
    setTimeout(() => {
      (document.getElementsByClassName("file")[0] as HTMLInputElement).click();
    }, 100);
  }
};
const cancel = () => {
  if (activeIndex.value == 2) {
    clearHonor();
    EntiyInfoDialogState.value = false;
  } else {
    clearShareInfo();
    EntiyInfoDialogState.value = false;
  }
};
const upload = async (e) => {
  const fileTarget: any = e.target;
  console.log(fileTarget.files);
  const tokenConsumer: OssTokenConsumer = async (
    token: OSSFederationToken
  ): Promise<void> => {
    if (token) {
      const client = new OSS({
        region: "oss-cn-hangzhou",
        accessKeyId: token.tempAK,
        accessKeySecret: token.tempSK,
        stsToken: token.securityToken,
        bucket: "gong-wei",
      });
      let fileList = [];
      for (const files of fileTarget.files) {
        fileList.push(files);
      }
      if (fileList.every((r) => CheckType.checkImgVideo(r.name))) {
        if (activeIndex.value == 2) {
          const fullFileName: string = IssueUtils.newFileName(
            token,
            fileList[0]
          );
          const result = await client.put(fullFileName, fileList[0]);
          honer.picture = IssueUtils.getResult(result);
        } else if (activeIndex.value == 3) {
          if (fileList.some((r) => CheckType.checkFileType(r.name) == 3)) {
            let VideoList = fileList.filter(
              (r) => CheckType.checkFileType(r.name) == 3
            );
            const fullFileName: string = IssueUtils.newFileName(
              token,
              VideoList[VideoList.length - 1]
            );
            const result = await client.put(
              fullFileName,
              VideoList[VideoList.length - 1]
            );
            shareInfo.imageUrls.splice(0, shareInfo.imageUrls.length);
            shareInfo.imageUrls.push(IssueUtils.getResult(result));
          } else if (fileList.length + shareInfo.imageUrls.length > 9) {
            ElMessage.warning("最多上传九张图片");
          } else {
            if (
              shareInfo.imageUrls[0] &&
              CheckType.checkFileType(shareInfo.imageUrls[0]) == 3
            ) {
              ElMessage.warning("视频与图片无法同时发布");
            } else {
              fileList.forEach(async (r) => {
                const fullFileName: string = IssueUtils.newFileName(token, r);
                const result = await client.put(fullFileName, r);
                console.log(result);
                shareInfo.imageUrls.push(IssueUtils.getResult(result));
              });
            }
          }
        }
      } else {
        ElMessage.warning("请上传正确文件格式");
      }
      (document.getElementsByClassName("file")[0] as HTMLInputElement).value =
        null;
    }
  };
  OSSCredentialProvider.getInstance().getFederationToken(tokenConsumer);
};
// 获取荣誉
const getHonorList = () => {
  honorList.splice(0, honorList.length);
  const pageSpec = new PageBlockAccessSpec();
  pageSpec.pageSize = 3;
  entiyinfo.getPersonHonor(UserTools.getUserId(), pageSpec).then((t) => {
    [...t.getPageData()].forEach((r) => {
      honorList.push({
        title: r.viewInfo.title,
        content: r.viewInfo.description,
        picture: r.viewInfo.imageUrls
          ? CheckType.isImg(r.viewInfo.imageUrls[0])
          : "",
      });
    });
  });
};
// 获取案例
const getCaseList = () => {
  caseList.splice(0, caseList.length);
  const pageSpec = new PageBlockAccessSpec();
  pageSpec.pageSize = 2;
  entiyinfo
    .getPersonCase(UserTools.getUserId(), UserInfoTabType.SHARED_INFO, pageSpec)
    .then((t) => {
      [...t.getPageData()].forEach((r) => {
        caseList.push({
          description: r.viewInfo.description,
          imageUrls: r.viewInfo.imageUrls,
          title: r.viewInfo.title,
          keywords: r.viewInfo.keywordEntities,
        });
      });
    });
  console.log(caseList);
};
watch(route, () => {
  activeIndex.value = Number(route.query.id) + 1;
});
onMounted(() => {
  activeIndex.value = Number(route.query.id) + 1;
  getHonorList();
  getCaseList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, {
          "separator-icon": _unref(ArrowRight) as any
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: {path:'/layout/home'} as any }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("信息维护")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chooseList[chooseList.findIndex((r) => r.id == activeIndex.value)].title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["separator-icon"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chooseList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["choosebox flex j-c a-c", activeIndex.value == item.id ? 'active' : '']),
                key: item.id,
                onClick: ($event: any) => (chooseInform(item.id))
              }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.id), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(item.title), 1),
                  _createElementVNode("h4", null, _toDisplayString(item.content), 1)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (activeIndex.value == 1)
              ? (_openBlock(), _createBlock(Brief, { key: 0 }))
              : _createCommentVNode("", true),
            (activeIndex.value == 3)
              ? (_openBlock(), _createBlock(Case, {
                  key: 1,
                  caseList: caseList,
                  onSharecase: sharecase
                }, null, 8, ["caseList"]))
              : _createCommentVNode("", true),
            (activeIndex.value == 2)
              ? (_openBlock(), _createBlock(Honor, {
                  key: 2,
                  honorList: honorList,
                  onIssuehonor: issuehonor
                }, null, 8, ["honorList"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[8] || (_cache[8] = ($event: any) => (activeIndex.value == 2 ? clearHonor() : clearShareInfo())),
      modelValue: EntiyInfoDialogState.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((EntiyInfoDialogState).value = $event)),
      title: activeIndex.value == 2 ? '新增荣誉' : '发布一个新的案例',
      width: "40%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_36, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (cancel())),
            class: "cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_37, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (issue()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("发布")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((honer.title) = $event)),
                placeholder: "写下荣誉名称..."
              }, null, 512), [
                [_vModelText, honer.title]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((honer.description) = $event)),
                placeholder: "晒晒自己的荣誉、行业资质..."
              }, null, 512), [
                [_vModelText, honer.description]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                (honer.picture)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "picture1",
                      src: _unref(CheckType).isImg(honer.picture),
                      alt: ""
                    }, null, 8, _hoisted_18))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "picture1",
                      src: _imports_0,
                      alt: "",
                      onClick: changeImg
                    })),
                _hoisted_19,
                _createElementVNode("input", {
                  type: "file",
                  hidden: "",
                  class: "file",
                  onChange: _cache[2] || (_cache[2] = (e) => upload(e)),
                  accept: accept.value
                }, null, 40, _hoisted_20)
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shareInfo.title) = $event)),
                placeholder: "写下案例标题..."
              }, null, 512), [
                [_vModelText, shareInfo.title]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("textarea", {
                class: "input-issue",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shareInfo.description) = $event)),
                placeholder: "分享案例内容..."
              }, null, 512), [
                [_vModelText, shareInfo.description]
              ])
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              (
          shareInfo.imageUrls.length == 0 ||
          _unref(CheckType).checkFileType(shareInfo.imageUrls[0]) == 4
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (
            shareInfo.imageUrls.length < 9 &&
            _unref(CheckType).checkFileType(shareInfo.imageUrls[0]) != 3
          )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "img",
                          src: _imports_0,
                          onClick: changeImg,
                          alt: ""
                        }))
                      : _createCommentVNode("", true),
                    (shareInfo.imageUrls.length == 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, " 上传案例配图(最多9张)或视频 "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareInfo.imageUrls, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        class: "img",
                        key: index,
                        src: _unref(CheckType).isImg(item),
                        "preview-src-list": [_unref(CheckType).isImg(item)],
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]))
                    }), 128)),
                    _createElementVNode("input", {
                      type: "file",
                      hidden: "",
                      class: "file",
                      onChange: _cache[5] || (_cache[5] = (e) => upload(e)),
                      accept: accept.value,
                      multiple: true
                    }, null, 40, _hoisted_29)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      (_unref(CheckType).checkFileType(shareInfo.imageUrls[0]) == 3)
                        ? (_openBlock(), _createBlock(Video, {
                            key: 0,
                            item: { link: _unref(CheckType).isImg(shareInfo.imageUrls[0]) },
                            height: 10
                          }, null, 8, ["item"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (activeIndex.value == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareInfo.keywords, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "label-write",
                    key: index,
                    contenteditable: "",
                    onInput: (e) => getMessage(e, index),
                    onBlur: (e) => getLabel(e, index),
                    textContent: _toDisplayString(item)
                  }, null, 40, _hoisted_35))
                }), 128)),
                _createElementVNode("button", { onClick: add }, "添加"),
                (shareInfo.keywords.length > 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: delate
                    }, " 删除 "))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})